import { FieldLabelColor, FieldLabelSize } from "./FieldLabel.types";

export const FIELD_LABEL_SIZE_CLASSES: Record<FieldLabelSize, string> = {
  sm: "text-xs",
  md: "text-sm",
  lg: "",
} as const;

export const FIELD_LABEL_COLOR_CLASSES: Record<FieldLabelColor, string> = {
  primary: "text-[#253747]",
  secondary: "",
} as const;
